import { Grid, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useAuth, useGlobalTitle } from '@/hooks';
import { Title } from '@/common/components';
import usePageTracking from '@/hooks/usePageTracking';
import { AdvisorAvailablitiy } from './components/advisor-availablity';
import styles from './styles.module.scss';
import { UpcomingSessionBlock } from './components/upcoming-session-block';
import { InboxBlock } from './components/inbox-block';
import { CompanyMetrics } from './components/company-metrics';
import { CompanyUsers } from './components/company-users';
import { FeedbackBlock } from './components/feedback-block';

const { useBreakpoint } = Grid;

export default function Home() {
  const { t } = useTranslation();
  const { user, isDecisionMaker, isAdvisor, isUser } = useAuth();
  const screens = useBreakpoint();
  const showColumnLayout = !screens.xl && !screens.xxl;
  // Set Global title to empty to clear the title
  useGlobalTitle('');
  usePageTracking();

  if (!user) {
    return <Result status={404} />;
  }

  if (Object.keys(screens).length === 0) {
    return null;
  }

  const renderUserLayout = () => {
    if (showColumnLayout) {
      return (
        <div className={styles.columnLayoutWrapper}>
          <InboxBlock isAdvisor={false} />
          <UpcomingSessionBlock />
          <FeedbackBlock isAdvisor={false} />
        </div>
      );
    } else {
      return (
        <div className={styles.wrapper}>
          <div className={styles.leftColumn}>
            <UpcomingSessionBlock />
          </div>
          <div className={styles.rightColumn}>
            <div className={classNames(styles.sessionBlocks)}>
              <InboxBlock isAdvisor={false} />
              <FeedbackBlock isAdvisor={false} />
            </div>
          </div>
        </div>
      );
    }
  };

  const renderAdvisorLayout = () => {
    if (showColumnLayout) {
      return (
        <div className={styles.columnLayoutWrapper}>
          <InboxBlock isAdvisor />
          <div>
            <AdvisorAvailablitiy />
          </div>
          <div>
            <UpcomingSessionBlock isAdvisor />
            <FeedbackBlock isAdvisor />
          </div>
        </div>
      );
    } else {
      return (
        <div className={styles.wrapper}>
          <div className={styles.leftColumn}>
            <AdvisorAvailablitiy />
          </div>
          <div className={classNames(styles.rightColumn)}>
            <InboxBlock isAdvisor />
            <div className={classNames(styles.sessionBlocks)}>
              <UpcomingSessionBlock isAdvisor />
              <FeedbackBlock isAdvisor />
            </div>
          </div>
        </div>
      );
    }
  };

  const renderDecisionLayout = () => {
    if (!user?.companyId) {
      return (
        <Title type="large" className={styles.title}>
          {t('message.decisionMakerWithoutCompany')}
        </Title>
      );
    }

    if (showColumnLayout) {
      return (
        <div className={styles.columnLayoutWrapper}>
          <CompanyUsers />
          <CompanyMetrics />
        </div>
      );
    } else {
      return (
        <div className={styles.wrapper}>
          <div className={styles.leftColumn}>
            <CompanyUsers />
          </div>
          <div className={styles.rightColumn}>
            <CompanyMetrics />
          </div>
        </div>
      );
    }
  };

  if (isUser) {
    return renderUserLayout();
  }

  if (isAdvisor) {
    return renderAdvisorLayout();
  }

  if (isDecisionMaker) {
    return renderDecisionLayout();
  }

  return (
    <div style={{ padding: 20 }}>
      <Title type="x-large">{t('home.welcomeTitle')}</Title>
    </div>
  );
}
